import React, { useState } from "react";
import { newsletter } from "../mock";
import { useToast } from "../hooks/use-toast";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", agree: false });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: "Please fill in your name and email." });
      return;
    }
    if (!form.agree) {
      toast({ title: "Please agree to be contacted." });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/newsletter`, { name: form.name, email: form.email });
      toast({
        title: "You're in",
        description: "Thanks for signing up to FERAL. Watch this space.",
      });
      setForm({ name: "", email: "", agree: false });
    } catch (err) {
      toast({ title: "Something went wrong", description: "Please try again in a moment." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="bg-[#2c6052] feral-texture-dark py-24 md:py-28 px-6">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="feral-serif text-[#ebc754] text-3xl md:text-5xl leading-tight mb-4">
          {newsletter.heading}
        </h2>
        <p className="text-[#f2e5de]/90 text-lg mb-10">{newsletter.intro}</p>

        <form onSubmit={handleSubmit} className="space-y-5 text-left">
          <div>
            <label className="block text-[#f2e5de] text-sm font-medium mb-2">
              Your Name *
            </label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full bg-[#f2e5de] text-[#1e231f] px-4 py-3 rounded-sm outline-none focus:ring-2 focus:ring-white/60"
            />
          </div>
          <div>
            <label className="block text-[#f2e5de] text-sm font-medium mb-2">
              Your Email *
            </label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-[#f2e5de] text-[#1e231f] px-4 py-3 rounded-sm outline-none focus:ring-2 focus:ring-white/60"
            />
          </div>
          <label className="flex items-start gap-3 text-[#f2e5de]/90 text-sm cursor-pointer">
            <input
              type="checkbox"
              checked={form.agree}
              onChange={(e) => setForm({ ...form, agree: e.target.checked })}
              className="mt-1 accent-[#ebc754] w-4 h-4"
            />
            <span>{newsletter.consent}</span>
          </label>
          <div className="pt-2 text-center">
            <button
              type="submit"
              disabled={submitting}
              data-testid="newsletter-submit-button"
              className="bg-[#ebc754] hover:bg-[#f2e5de] disabled:opacity-60 text-[#9b3d0a] px-12 py-3.5 tracking-[0.15em] text-sm font-semibold transition-colors duration-300"
            >
              {submitting ? "SENDING…" : "SUBMIT"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
